import { render, staticRenderFns } from "./ModulesForRoles.vue?vue&type=template&id=49e2abf0&scoped=true"
import script from "./ModulesForRoles.vue?vue&type=script&lang=js"
export * from "./ModulesForRoles.vue?vue&type=script&lang=js"
import style0 from "./ModulesForRoles.vue?vue&type=style&index=0&id=49e2abf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e2abf0",
  null
  
)

export default component.exports